<template>
  <svg
    :x="x"
    :y="y"
    width="150"
    height="175"
    viewBox="0 0 102 139"
    xmlns="http://www.w3.org/2000/svg"
    class="svg-streetlamp"
  >
    <defs>
      <linearGradient
        id="lightlinear2"
        x1="46.353"
        y1="-119.5"
        x2="46.353"
        y2="60.984"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#f9df81" />
        <stop offset="1" stop-color="#f9df81" stop-opacity="0.1" />
      </linearGradient>
    </defs>
    <path
      d="M22.49 5.218a.5.5 0 01.743.438v129.472a.502.502 0 01-.257.437l-4.896 2.72a.5.5 0 01-.743-.437V8.376a.5.5 0 01.257-.438l4.897-2.72z"
      fill="#C6B4B7"
      stroke="#0E1E25"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M36.878 23.608L.156 82.36s60.66 51.136 101.189-12.512L55.647 25.512l-18.769-1.904z"
      fill="url(#lightlinear2)"
    />
    <path
      d="M21.121 6.04a.5.5 0 01.75.487l-.545 4.896a.5.5 0 01-.257.384l-2.992 1.632a.5.5 0 01-.74-.44V9.465c0-.041.005-.082.015-.122l.272-1.088a.5.5 0 01.233-.31l3.264-1.904z"
      fill="url(#lightlinear2)"
      stroke="#0E1E25"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.837 8.376l4.896-2.72-4.896-2.72-4.624 2.72 4.624 2.72z"
      fill="#F1EEE8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.47 7.56l-4.625-2.72-1.36.544 4.624 2.992 1.36-.816z"
      fill="#B3A2A6"
    />
    <path
      d="M12.713 5.656a.5.5 0 01.753-.431l4.625 2.72a.5.5 0 01.246.43v129.473a.502.502 0 01-.753.43l-4.625-2.72a.498.498 0 01-.246-.43V5.656z"
      fill="#A29296"
      stroke="#0E1E25"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.47 4.024l-4.625 2.72-1.36-.816 4.624-2.72 1.36.816z"
      fill="#B3A2A6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.021 7.832V6.2l1.36-.816v1.904l-1.36.544z"
      fill="#2D090A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.021 6.2l-2.176-1.36 1.088-.816 2.448 1.36-1.36.816z"
      fill="#402F30"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.021 7.832l-1.088-.544-1.088-.544V4.84l1.088.544 1.088.816v1.632z"
      fill="#2D090A"
    />
    <path
      d="M47.735 27.578a.5.5 0 01-.493.002l-11.153-6.256a.5.5 0 01-.008-.868l7.889-4.624a.5.5 0 01.51.003l10.88 6.528a.5.5 0 01-.009.863l-7.616 4.352z"
      fill="#F1EEE8"
      stroke="#0E1E25"
      stroke-linejoin="round"
    />
    <path
      d="M35.834 20.888a.5.5 0 01.745-.436l11.152 6.256a.5.5 0 01.256.436v4.624a.5.5 0 01-.745.436l-11.153-6.256a.5.5 0 01-.255-.436v-4.624z"
      fill="#A29296"
      stroke="#0E1E25"
      stroke-linejoin="round"
    />
    <path
      d="M54.855 22.357a.5.5 0 01.748.434v4.625a.5.5 0 01-.252.434l-7.616 4.352a.5.5 0 01-.748-.434v-4.625a.5.5 0 01.252-.434l7.616-4.352z"
      fill="#C6B4B7"
      stroke="#0E1E25"
      stroke-linejoin="round"
    />
    <path
      d="M46.894 24.055a.5.5 0 01-.223.053h-1.904a.5.5 0 01-.252-.069l-6.529-3.808a.5.5 0 01-.048-.831l1.088-.816a.5.5 0 01.542-.038l7.888 4.352a.5.5 0 01-.018.885l-.544.272z"
      fill="#B3A2A6"
      stroke="#0E1E25"
      stroke-linejoin="round"
    />
    <path
      d="M46.936 24.032a.5.5 0 01-.765-.424v-1.905a.5.5 0 01.276-.447l2.176-1.088a.5.5 0 01.724.448v1.631a.5.5 0 01-.235.425l-2.176 1.36z"
      fill="#2D090A"
      stroke="#0E1E25"
      stroke-linejoin="round"
    />
    <path
      d="M46.894 22.15a.5.5 0 01-.471-.012L14.053 3.642a.5.5 0 01.005-.871l2.448-1.36a.5.5 0 01.496.005l32.097 18.768a.5.5 0 01-.029.879l-2.176 1.088z"
      fill="#402F30"
      stroke="#0E1E25"
      stroke-linejoin="round"
    />
    <path
      d="M47.17 23.608a.5.5 0 01-.75.432L14.05 5.272a.5.5 0 01-.249-.432V3.208a.5.5 0 01.748-.434L46.92 21.27a.5.5 0 01.252.434v1.904z"
      fill="#2D090A"
      stroke="#0E1E25"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  props: {
    x: {
      type: [Number, String],
      default: 1000
    },
    y: {
      type: [Number, String],
      default: 300
    }
  }
};
</script>

<style lang="scss" scoped>
</style>